import React, { useEffect, useState } from "react";
import "./RightsSettings.scss";
import {
  getRights,
  updateRights,
  getUserRightsByToken,
} from "../../../services/api/GlobalSettingsApi";
import { useAuth } from "../../../context/AuthContext";
import { useToast } from "../../../context/ToastContext";
import { useNavigate } from "react-router-dom";
import JusticeLoader from "../../../components/JusticeLoader/JusticeLoader";
import Cookies from "js-cookie";

const RightsSettings = () => {
  const { company, setCompany, setvisibility } = useAuth();
  const [rights, setRights] = useState({});
  const [loading, setLoading] = useState(false);
  const [fetchingData, setFetchingData] = useState(true);
  const navigate = useNavigate();
  const { showToast } = useToast();

  const allDisplayKeys = [
    { key: "cases", label: "Cases" },
    { key: "clients", label: "Clients" },
    { key: "expenses", label: "Expenses" },
    { key: "invoices", label: "Invoices" },
    { key: "labels", label: "Labels" },
    { key: "mobileAppAccess", label: "Mobile Access" },
    { key: "notes", label: "Notes" },
    { key: "tasks", label: "Tasks" },
    { key: "teams", label: "Teams" },
    { key: "branch", label: "Branch" },
  ];

  // Filter display keys based on fetched rights
  const [displayKeys, setDisplayKeys] = useState([]);

  useEffect(() => {
    const fetchRights = async () => {
      try {
        setFetchingData(true);
        const res = await getRights();
        if (res) {
          setRights(res.data);
          
          // Filter displayKeys to only show rights that exist in the response
          const filteredKeys = allDisplayKeys.filter(
            ({ key }) => res.data.hasOwnProperty(key)
          );
          setDisplayKeys(filteredKeys);
        }
      } catch (err) {
        console.error("Error fetching rights:", err);
        showToast("Failed to fetch rights settings.", "error");
        setRights({});
        setDisplayKeys([]);
      } finally {
        setFetchingData(false);
      }
    };
    fetchRights();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (fetchingData) {
    return (
      <section className="rights-settings">
        <h3 className="rights-settings-title">Rights Settings</h3>
        <JusticeLoader message="Loading rights settings..." type="gavel" />
      </section>
    );
  }

  const handleToggle = (key) => {
    setRights((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleSave = async () => {
    // Only include rights that are currently displayed
    const payload = {
      rights: displayKeys.reduce((acc, { key }) => {
        acc[key] = rights[key] ?? false;
        return acc;
      }, {}),
    };

    setLoading(true);
    try {
      console.log(payload, "payyyyy");
      await updateRights(payload);

      const updatedCompany = {
        ...company,
        ...payload,
        superAdmin: company?.rights?.superAdmin ?? false,
      };

      setCompany(updatedCompany);
      localStorage.setItem("company", JSON.stringify(updatedCompany));

      // Fetch updated visibility/rights for the current user
      try {
        const userRightsResponse = await getUserRightsByToken();
        if (userRightsResponse?.data) {
          const updatedVisibility = userRightsResponse.data;
          
          // Update visibility in AuthContext
          setvisibility(updatedVisibility);
          
          // Update visibility in localStorage
          localStorage.setItem("visibility", JSON.stringify(updatedVisibility));
          
          // Update visibility in Cookies
          Cookies.set("visibility", JSON.stringify(updatedVisibility), {
            expires: 7,
            secure: true,
            sameSite: "Strict",
          });
          
          console.log("Updated visibility:", updatedVisibility);
        }
      } catch (visibilityError) {
        console.error("Error fetching updated user rights:", visibilityError);
        // Don't fail the entire operation if visibility fetch fails
      }

      showToast("Rights updated successfully.", "success");
      setTimeout(() => {
        navigate("/home/displayboard");
      }, 300);
    } catch (err) {
      console.error("Error updating rights:", err);
      showToast("Something went wrong to update Rights!", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="rights-settings">
        <h3 className="rights-settings-title">Rights Settings</h3>

        <div className="settings-container">
          <div className="settings-card">
            <h4 className="card-title">Module Access Permissions</h4>
            {displayKeys.length > 0 ? (
              <div className="rights-grid">
                {displayKeys.map(({ key, label }) => (
                  <div className="rights-item" key={key}>
                    <label>{label}</label>
                    <div className="toggle-switch">
                      <input
                        type="checkbox"
                        checked={rights[key] || false}
                        onChange={() => handleToggle(key)}
                        id={key}
                      />
                      <label htmlFor={key} className="toggle-slider"></label>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="no-rights-message">
                No rights available for your plan.
              </p>
            )}
          </div>
        </div>

        <div className="action-buttons">
          <button
            className="cancel-btn"
            onClick={() => navigate("/home/displayboard")}
          >
            Cancel
          </button>
          <button
            className="save-btn"
            onClick={handleSave}
            disabled={loading || displayKeys.length === 0}
          >
            {loading ? "Saving..." : "Save Rights Changes"}
          </button>
        </div>
      </section>
    </>
  );
};

export default RightsSettings;